import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Chip, IconButton, Menu, MenuItem, Tooltip, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { HOME_TEMPLATE_FILTER_NONE } from './redux/constants';

const FilterCaseTemplates = ({ templates, selectedTemplates, onAdd, onRemove }) => {
  if (!templates || templates.length === 0) {
    return null;
  }

  const [anchorEl, setAnchorEl] = useState(null);

  const availableTemplates = useMemo(
    () => templates.filter(({ value }) => !selectedTemplates.includes(value)),
    [templates, selectedTemplates],
  );

  const handleOpenMenu = (event) => {
    if (availableTemplates.length === 0) return;
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => setAnchorEl(null);

  const handleSelectTemplate = (value) => {
    onAdd(value);
    handleCloseMenu();
  };

  const getTemplateLabel = (value) => {
    if (value === HOME_TEMPLATE_FILTER_NONE) {
      return 'No template';
    }
    const template = templates.find((item) => item.value === value);
    return template && template.label ? template.label : value;
  };

  return (
    <div className="case-template-filter">
      <Tooltip title="Add template filter">
        <span>
          <IconButton
            size="small"
            className="case-template-filter__add"
            onClick={handleOpenMenu}
            disabled={availableTemplates.length === 0}
          >
            <AddIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseMenu} disablePortal>
        {availableTemplates.map(({ value }) => (
          <MenuItem key={value} onClick={() => handleSelectTemplate(value)}>
            {getTemplateLabel(value)}
          </MenuItem>
        ))}
        {availableTemplates.length === 0 && <MenuItem disabled>No templates available</MenuItem>}
      </Menu>
      {selectedTemplates.map((value) => (
        <Chip
          key={value}
          label={getTemplateLabel(value)}
          size="small"
          color="primary"
          className="case-template-filter__chip"
          onDelete={() => onRemove(value)}
        />
      ))}
    </div>
  );
};

FilterCaseTemplates.propTypes = {
  templates: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string,
    }),
  ),
  selectedTemplates: PropTypes.arrayOf(PropTypes.string),
  onAdd: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};

FilterCaseTemplates.defaultProps = {
  templates: [],
  selectedTemplates: [],
};

export default FilterCaseTemplates;
